// src/components/SuccessMessage.jsx
import React from "react";
import { FiCheckCircle } from "react-icons/fi";

/**
 * Standardized Success Message Component
 * @param {string} message - Success message to display
 * @param {string} className - Optional CSS class name
 * @param {object} style - Optional inline styles
 */
export default function SuccessMessage({ message, className = "", style = {} }) {
  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={className}
      style={{
        background: "#f0fdf4",
        color: "#166534",
        border: "1px solid #bbf7d0",
        padding: "12px 16px",
        borderRadius: 10,
        fontSize: 14,
        marginBottom: 15,
        display: "flex",
        alignItems: "center",
        gap: 8,
        ...style,
      }}
    >
      <FiCheckCircle size={16} style={{ flexShrink: 0 }} />
      <span>{message}</span>
    </div>
  );
}
